import { createGlobalStyle } from 'styled-components';

import { device } from './helpers';
import theme from '@/theme';

import 'rc-tooltip/assets/bootstrap_white.css';

export const GlobalStyles = createGlobalStyle<{ theme: typeof theme }>`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  body {
    background-color: ${({ theme }) => theme.blackColor};
    color: ${({ theme }) => theme.whiteColor};
  }

  #chatra:not(.chatra--expanded) {
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none;
  }


  .close {
    color: ${({ theme }) => theme.blackColor};
  }

  #root {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 100vh;
  }

  input, button, textarea {
    font-family: inherit;
		border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    &:focus {
      outline: none
    }
  }

  img {
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.secondaryColor};
  }

	*:focus,
	*:active {
		-webkit-tap-highlight-color: rgba(0,0,0,0);
	}

  #nprogress {
    .spinner {
      top: 29px;
    }
    .spinner-icon {
      border-top-color: ${({ theme }) => `${theme.mainColor} !important`};
      border-left-color: ${({ theme }) => `${theme.mainColor} !important`};
    }
    .bar {
      background: ${({ theme }) => `${theme.mainColor} !important`};
      .peg {
        box-shadow: ${({ theme }) =>
          `0 0 10px ${theme.mainColor}, 0 0 5px ${theme.mainColor}`};
      }
    }
  }

  .tournament-iframe {
    @media(${device.mobileS}) {
      overflow-x: auto;
      iframe {
        min-width: 450px;
      }
    }
  }
`;
